import { createReducer } from '@reduxjs/toolkit';
import { rehireAttributeActions } from '~/behaviors/actions/rehireAttribute.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';

const defaultState = {};

const reset = () => defaultState;

const set = (state, { payload }) => {
  state.rehireAttributeId = payload?.rehireAttributeId;
};

const rehireAttribute = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(rehireAttributeActions.setRehireAttribute.fulfilled, set)
    .addCase(rehireAttributeActions.getRehireAttribute.fulfilled, set);
});

export default rehireAttribute;
